<template>
  <v-dialog
    v-model="internalModelValue"
    :fullscreen="$vuetify.display.smAndDown"
    width="470"
    persistent
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar color="primary">
          <v-toolbar-title>{{ $t('connection-manager.import-export.export') }} </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon="mdi-close"
              @click="internalModelValue = false"
            />
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <p>{{ $t('connection-manager.export-dialog.description') }}</p>
        <v-radio-group v-model="exportType">
          <v-radio
            value="all"
            :label="$t('labels.export.all-contacts')"
          />
          <v-radio
            value="non-exported"
            :label="$t('labels.export.non-exported')"
          />
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          variant="flat"
          color="primary"
          @click="exportContacts"
        >
          <v-icon class="icon--rotate mr-1">mdi-upload</v-icon>
          {{ $t('labels.export.title') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

const internalModelValue = defineModel<boolean>('modelValue', { required: true })

export type ExportType = 'all' | 'non-exported'

const emit = defineEmits<{
  (e: 'export', exportType: ExportType): void
}>()

const exportType = ref<ExportType>('all')

const exportContacts = async () => {
  emit('export', exportType.value)
  internalModelValue.value = false
}
</script>
<style scoped>
.icon--rotate {
  transform: rotate(90deg);
}
</style>
